import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "v-stepper" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "v-stepper__index" }
const _hoisted_4 = { class: "v-stepper__title" }
const _hoisted_5 = {
  key: 0,
  class: "v-stepper__divider"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VStepper',
  props: {
    steps: null,
    modelValue: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { steps: string[], modelValue: number }





const itemClick = (index: number) => {
  if (index >= props.modelValue) return
  emit("update:modelValue", index)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.steps, (item, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", {
          class: _normalizeClass(["v-stepper-item", { active: index < props.modelValue }]),
          onClick: ($event: any) => (itemClick(index+1))
        }, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(index+1), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(item), 1)
        ], 10, _hoisted_2),
        (index != props.steps.length-1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5))
          : _createCommentVNode("", true)
      ], 64))
    }), 256))
  ]))
}
}

})